import { render, staticRenderFns } from "./certificates.vue?vue&type=template&id=ef298d94&"
import script from "./certificates.vue?vue&type=script&lang=js&"
export * from "./certificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/certificates.vue
// module id = 1623
// module chunks = 0